// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__6xshD","description":"PatientConsentPreview_description__3OOQS"};